import React from 'react';
import ReactDOM from 'react-dom';
import { Spin, ConfigProvider } from 'antd';
import vi_VN from 'antd/lib/locale-provider/vi_VN';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import en_US from 'antd/lib/locale-provider/en_US';
import { Provider as StoreProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import '@elastic/eui/dist/eui_theme_amsterdam_light.min.css';
import 'antd/dist/antd.css';
import moment from 'moment-timezone';
import IntlProviderWrap from 'components/IntlProviderWrap';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { appConfig } from 'config';
import App from './app';
import * as serviceWorker from './serviceWorker';
import './styles.less';
import { store, persistor } from './reducers/store';
// lamdt test
console.log('RT-', appConfig.release_type);

if (process.env.REACT_APP_SENTRY_DSN && process.env.NODE_ENV === 'production') {
  console.log('Senstry is actived ', process.env.REACT_APP_SENTRY_DSN);
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

moment.tz.setDefault('Asia/Saigon');
const getLocale = () => {
  const locale = localStorage.getItem('language');
  if (!locale) return vi_VN;
  if (locale === 'cn') return zh_CN;
  return en_US;
};

ReactDOM.render(
  <StoreProvider store={store}>
    <PersistGate
      loading={<Spin className="app-spinner" />}
      persistor={persistor}
    >
      <ConfigProvider locale={getLocale()}>
        <IntlProviderWrap>
          <App />
        </IntlProviderWrap>
      </ConfigProvider>
    </PersistGate>
  </StoreProvider>,
  document.getElementById('root')
);

if (process.env.REACT_APP_ENV === 'production') {
  serviceWorker.register();
} else {
  serviceWorker.unregister();
}
